import { createSlice } from '@reduxjs/toolkit';

import { resetStoresAction } from 'common/actions/common';

type RegistrationState = {
  isFetching: boolean;
  message: string;
  error: string;
  errorData: object;
  isUserDataCheckingPassed: boolean;
  isUserDataCheckingIsInProgress: boolean;
};

export type RegistrationPartialState = {
  registration: RegistrationState;
};

const defaultState: RegistrationState = {
  isFetching: false,
  message: '',
  error: '',
  errorData: {},
  isUserDataCheckingPassed: false,
  isUserDataCheckingIsInProgress: false,
};

const setFetching = (state: RegistrationState): RegistrationState => ({
  ...state,
  isFetching: true,
});

const registration = createSlice({
  name: 'registration',
  initialState: defaultState,
  reducers: {
    registrationAction: setFetching,
    registrationFailedAction: (state, { payload: { error, errorData } }) => ({
      ...state,
      isFetching: false,
      isUserDataCheckingPassed: false,
      error,
      errorData,
    }),
    registrationSuccessAction: () => defaultState,
    checkingUserDataStartAction: (state) => ({
      ...state,
      isUserDataCheckingIsInProgress: true,
    }),
    checkingUserDataFailedAction: (
      state,
      { payload: { error, errorData } },
    ) => ({
      ...state,
      error,
      errorData,
      isUserDataCheckingIsInProgress: false,
    }),
    checkingUserDataSuccessAction: (state) => ({
      ...state,
      isUserDataCheckingPassed: true,
      isUserDataCheckingIsInProgress: false,
    }),
    checkingUserDataPassedAction: (
      state,
      { payload: isUserDataCheckingPassed },
    ) => ({
      ...state,
      isUserDataCheckingPassed,
    }),
    resetErrorsAction: () => defaultState,
  },
  extraReducers: (builder) =>
    builder.addCase(resetStoresAction, () => defaultState),
});

export const {
  registrationAction,
  registrationFailedAction,
  registrationSuccessAction,
  checkingUserDataStartAction,
  checkingUserDataFailedAction,
  checkingUserDataSuccessAction,
  checkingUserDataPassedAction,
  resetErrorsAction,
} = registration.actions;

export default registration.reducer;
